import { stringify } from 'qs';
import { AxiosError } from 'axios';
import IPagination from '../../../common/interfaces/IPagination';
import { getCarrierAxiosInstance } from '../../../common/services/axios-config';
import BranchesConstants from '../constants';
import IBranchListData from '../interfaces/IBranchListData';
import IBranchesListRequest from '../interfaces/IBranchesListRequest';
import IBranchesFiltersModel from '../interfaces/IBranchesFiltersModel';
import IApiError from '../../../common/errors/interfaces/IApiError';
import ProcessingError, {
    getProcessingErrors,
    isProcessingError,
} from '../../../common/errors/processing-error';
import CONTACT_SUPPORT_MESSAGE from '../../../common/constants/messages';
import IBranchTableData from '../interfaces/IBranchTableData';
import i18n from '../../../lib/i18n';

const getBranches = async (
    carrierId: string,
    filters?: IBranchesFiltersModel,
    page: number = 1,
    pageSize: number = BranchesConstants.PAGE_SIZE,
): Promise<IPagination<IBranchListData>> => {
    const request: IBranchesListRequest = {
        filters,
        _page: page,
        _size: pageSize,
    } as IBranchesListRequest;

    const Api = await getCarrierAxiosInstance();

    const response = await Api.get(
        `v1/carriers/${carrierId}/branches:paginated`,
        {
            params: request,
            paramsSerializer(params) {
                return stringify(params, { allowDots: true });
            },
        },
    ).catch(() => {
        throw new Error(i18n.t('ErroConsultarFilial'));
    });

    return (response.data || {}) as IPagination<IBranchListData>;
};

const deleteBranches = async (
    carrierId: string,
    branchesSelected: IBranchTableData[],
): Promise<string> => {
    const api = await getCarrierAxiosInstance();

    const response = await api
        .post(
            `v1/carriers/${carrierId}/branches:delete`,
            branchesSelected.map(b => b.id),
        )
        .catch((error: AxiosError<IApiError>) => {
            if (isProcessingError(error)) {
                const exceptionBranchNames = getProcessingErrors(
                    error,
                    branchesSelected.map(branch => ({
                        id: branch.id,
                        name: branch.corporateName,
                    })),
                );

                if (exceptionBranchNames.length > 0) {
                    const branchNames = exceptionBranchNames.join(', ');
                    const errorMessage = `${i18n.t('AsFilias')}: ${branchNames}. ${i18n.t(CONTACT_SUPPORT_MESSAGE)}`;

                    throw new ProcessingError(errorMessage);
                }
            }

            throw new Error(i18n.t(CONTACT_SUPPORT_MESSAGE));
        });

    return response.data;
};

const BranchesService = {
    getBranches,
    deleteBranches,
};

export default BranchesService;
